import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';

@Component({
  selector: 'megastore-admin-submit-driver-cash',
  templateUrl: './submit-driver-cash.component.html',
  styleUrls: ['./submit-driver-cash.component.scss']
})
export class SubmitDriverCashComponent {
  allDrivers: any[] = [];
  // form: FormGroup = this.fb.group({
  //   driverId: new FormControl(''),
  //   amount: new FormControl(''),
  // });
  driverId = new FormControl('');
  amount = new FormControl('');
  constructor(
    public dialogRef: MatDialogRef<SubmitDriverCashComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder
  ) {
    this.driverId.setValue(data.driverId);
    // console.log('Received Data in Modal:', data);
  }

  onSubmit(): void {
    console.log(this.driverId.value, this.amount.value);
    this.dialogRef.close({ driverId: this.driverId.value, cash: this.amount.value });
  }
}

